<div class="radioBox-item"
     *ngFor="let radio_item of radio_items"
     [ngClass]="{ '-selected': _value?.value === radio_item.value }"
     (click)="radioItemSelected(radio_item)">
  {{radio_item.label}}
  <tooltip-popover *ngIf="!!radio_item?.tooltip" [tooltip_content]="radio_item.tooltip">
  </tooltip-popover>
</div>
